export default {
  site_title: 'Exhibition Website',
  more: 'More',
  packUp: 'Pack up',
  view: 'View',
  internation: 'Internation',
  china: 'China',
  industry: 'Industry',
  fair: 'Fair',
  expo: 'Expo',
  concurrentFair: 'Concurrent fair',
  vote: 'Ticket',
  search: 'Search',
  boothInquiry: 'Booth',
  ticketBooking: 'Ticket',
  exhibitorECatalog: 'Exhibitor/E-Catalog Access',
  booth: 'Booth',
  ticket: 'Ticket',
  news: 'News',
  catalog: 'Catalog'
}
